import { getVariant } from 'core/experiment'
import {
  PPI_1026_V2_DENTAL_PLAN_DETAILS,
  PPI_1026_V2_DENTAL_PLAN_DETAILS_VARIANTS
} from 'core/constants/experiments'

export function enableV2DentalPlanDetails(): boolean {
  const variant = getVariant({
    experimentKey: PPI_1026_V2_DENTAL_PLAN_DETAILS,
    fallback: PPI_1026_V2_DENTAL_PLAN_DETAILS_VARIANTS.OFF
  })

  return variant === PPI_1026_V2_DENTAL_PLAN_DETAILS_VARIANTS.ON
}
